module.exports = require("@angular/cdk/bidi");


//////////////////
// WEBPACK FOOTER
// external "@angular/cdk/bidi"
// module id = 1000
// module chunks = 0